import { Spinner as ArmstrongSpinner } from '@rocketmakers/armstrong';
import * as React from 'react';
import { SeroProps } from '../props/SeroProps';
import './spinner.scss';

export const Spinner: React.FunctionComponent<SeroProps> = ({ 'data-qa': dataQa = 'spinner' }) => {
  return (
    <div className="spinner" data-qa={dataQa}>
      <ArmstrongSpinner />
    </div>
  );
};
